<template>
  <v-container class="d-flex justify-center flex-column">
    <v-list>
      <v-list-item
        @click="badgeEarnedModal = !badgeEarnedModal"
        class="outlinedListItem">
        <v-list-item-avatar
          size=30>
          <v-img
            id="badgeAvatar"
            :src="badgeAdded.image || badgeAdded.image_url"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            class="text-left">
            Badge Earned!
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-dialog
      id="badgeModal"
      v-model="badgeEarnedModal"
      transition="dialog-top-transition"
      max-width=500>
      <v-card>
        <v-card-title
          id="badgeNameTitle">
          {{ badgeAdded.name }}
        </v-card-title>
        <v-card-subtitle
          id="badgeDescriptionSubtitle">
          {{ badgeAdded.description }}
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col
              cols=3>
              <v-img
                contain
                width="100"
                :src="badgeAdded.image || badgeAdded.image_url">
              </v-img>
              <v-btn
                id="badgrDownloadButton"
                v-if="badgrEnabled"
                small
                class="mt-2"
                dark
                :color="playlist.default_color"
                :href="badgeAssertion.openBadgeId"
                target="blank">
                Download
              </v-btn>
              <v-btn
                id="credlyAcceptButton"
                v-else-if="credlyEnabled && badgeAssertion.state === 'pending'"
                small
                class="mt-2"
                dark
                :color="playlist.default_color"
                :href="badgeAssertion.accept_badge_url"
                target="blank">
                Accept Badge
              </v-btn>
              <v-btn
                id="credlyViewButton"
                v-else
                small
                class="mt-2"
                dark
                :color="playlist.default_color"
                :href="badgeAdded.url"
                target="blank">
                View Badge
              </v-btn>
            </v-col>
            <v-col
              class="justify-start">
              <v-list>
                <v-list-item
                  two-line>
                    <v-list-item-content>
                      <v-list-item-title>Recipient</v-list-item-title>
                      <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                  two-line>
                    <v-list-item-content
                      v-if="badgrEnabled">
                      <v-list-item-title>Criteria</v-list-item-title>
                      <v-list-item-subtitle>
                        <a
                          id="badgrCriteriaLink"
                          :href="badgeAdded.openBadgeId" target="_blank">View Criteria</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  mapState,
} from 'vuex';
import _ from 'lodash';

export default {
  name: 'BadgeAssertionModal',
  props: {
    badgeAdded: {
      type: Object,
      default() {
        return {};
      },
    },
    badgeAssertion: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    badgeEarnedModal: false,
  }),
  computed: {
    ...mapState([
      'playlist',
      'user',
    ]),
    badgrEnabled() {
      return !!_.get(this.playlist, 'badge.badgr.enabled', false);
    },
    credlyEnabled() {
      return !!_.get(this.playlist, 'badge.credly.enabled', false);
    },
  },
};
</script>

<style>
  .outlinedListItem {
    border: 1px solid #ccc;
    border-radius: 16px;
  }
</style>
